import React, { useContext } from 'react';
import BarChart from 'components/@common/Charts/BarChart';
import { PrintViewContext } from '../../../../providers/PrintViewProvider';

interface EnrichmentActivityChartProps {
  hearItTypeItCompletedSeries: number[];
  myChoiceKeyboardingCompletedSeries: number[];
  teacherCreatedActivityCompletedSeries: number[];
  labels: string[];
}

const EnrichmentActivityChart: React.FC<EnrichmentActivityChartProps> = ({
  hearItTypeItCompletedSeries,
  myChoiceKeyboardingCompletedSeries,
  teacherCreatedActivityCompletedSeries,
  labels
}): React.ReactElement => {
  const { fullChartWidth } = useContext(PrintViewContext);

  return (
    <BarChart
      height={250}
      width={fullChartWidth}
      series={[
        {
          name: 'Hear It, Type It',
          data: hearItTypeItCompletedSeries
        },
        {
          name: 'Teacher Custom Creation',
          data: teacherCreatedActivityCompletedSeries
        },
        {
          name: 'My Choice Keyboarding',
          data: myChoiceKeyboardingCompletedSeries
        }
      ]}
      options={{
        chart: {
          stacked: true,
          toolbar: { show: false }
        },
        colors: ['#A165B7', '#4AE2A7', '#F4A520'],
        yaxis: [
          {
            decimalsInFloat: 0,
            title: {
              offsetX: -2,
              text: 'Activities',
              style: {
                color: '#373D3F',
                fontSize: '12px',
                fontWeight: 700,
                fontFamily: 'futura-pt'
              }
            }
          }
        ],
        xaxis: {
          categories: labels,
          labels: {
            offsetY: -4,
            style: {
              colors: '#373D3F',
              fontSize: '10px',
              fontFamily: 'futura-pt'
            }
          },
          axisTicks: { show: false }
        },
        legend: {
          offsetY: 2,
          horizontalAlign: 'left'
        },
        dataLabels: { enabled: false }
      }}
    />
  );
};

export default React.memo(EnrichmentActivityChart);
